import PropTypes from 'prop-types'

import IconKebabMenu from '@adv-mt/mt-svg-icons/lib/KebabMenu.js'

const BASE_CLASS = 'mt-CardAd-menuIcon'

const CardAdMenuIcon = ({onClick}) => {
  return (
    <div onClick={onClick} className={BASE_CLASS}>
      <IconKebabMenu size="medium" />
    </div>
  )
}
CardAdMenuIcon.displayName = 'CardAdMenuIcon'
CardAdMenuIcon.propTypes = {
  onClick: PropTypes.func
}

export default CardAdMenuIcon
